import React, { Component } from "react";
import { Link } from "react-router-dom";

class Footer_v1 extends Component {
  componentDidMount() {
    const $ = window.$;

    let publicUrl = process.env.PUBLIC_URL + "/";
    const minscript = document.createElement("script");
    minscript.async = true;
    minscript.src = publicUrl + "assets/js/main.js";

    document.body.appendChild(minscript);

    var bodyOvrelay = $("#body-overlay");
    var searchPopup = $("#td-search-popup");

    $(document).on("click", "#body-overlay", function (e) {
      e.preventDefault();
      bodyOvrelay.removeClass("active");
      searchPopup.removeClass("active");
    });
    $(document).on("click", ".search", function (e) {
      e.preventDefault();
      searchPopup.addClass("active");
      bodyOvrelay.addClass("active");
    });
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let imgattr = "Footer logo";

    return (
      <div className="footer-area bg-black pd-top-95">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="widget">
                <h5 className="widget-title">ABOUT US</h5>
                <div className="widget_about">
                  <p>
                    WE R News is your trusted source for the latest news,
                    trending stories, and insightful articles from India and
                    around the world. Our mission is to deliver accurate,
                    balanced, and timely news to our readers across a wide range
                    of categories, including politics, entertainment, sports,
                    technology, lifestyle, and more.
                  </p>
                  <ul className="social-area social-area-2 mt-4">
                    <li>
                      <a
                        className="facebook-icon"
                        href="https://www.facebook.com/WeRNews/"
                      >
                        <i className="fa fa-facebook" />
                      </a>
                    </li>
                    <li>
                      <a
                        className="twitter-icon"
                        href="https://x.com/WeRNewsLive"
                      >
                        <i className="fa-brands fa-x-twitter" />
                      </a>
                    </li>
                    <li>
                      <a
                        className="youtube-icon"
                        href="https://www.youtube.com/@WeRNewsLive"
                      >
                        <i className="fa fa-youtube-play" />
                      </a>
                    </li>
                    <li>
                      <a
                        className="instagram-icon"
                        href="https://www.instagram.com/wernewslive/"
                      >
                        <i className="fa fa-instagram" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="widget widget_tag_cloud">
                <h5 className="widget-title">TAGS</h5>
                <div className="tagcloud go-top">
                  <Link to="/रुबरू-with-राजीव">रुबरू <span className="with" style={{textTransform:"lowercase"}}>With</span> राजीव</Link>
                  <Link to="/category/न्यूज़">न्यूज़</Link>
                  <Link to="/category/web-stories">वेब स्टोरी</Link>
                  <Link to="/category/मनोरंजन">मनोरंजन</Link>

                  <Link to="/category/धर्म">धर्म</Link>
                  <Link to="/category/बिजनेस">बिजनेस</Link>
                  <Link to="/category/हेल्थ">हेल्थ</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="widget">
                <h5 className="widget-title">CONTACTS</h5>
                <ul className="contact_info_list">
                  {/* <li><i className="fa fa-map-marker" /> 829 Cabell Avenue Arlington, VA 22202</li> */}
                  {/* <li><i className="fa fa-phone" /> +088 012121240</li> */}
                  <a href="mailto:wermarketingmedia@gmail.com" target="_blank">
                    {" "}
                    <li>
                      <i className="fa fa-envelope-o" />{" "}
                      wermarketingmedia@gmail.com
                    </li>
                  </a>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 go-top">
              <div className="widget widget_recent_post">
                <div className="single-post-list-wrap style-white">
                  <div className="media">
                    <div className="media-left">
                      <img
                        src={"/assets/img/logos.png"}
                        alt="img"
                        width={230}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom text-center">
            {/* <ul className="widget_nav_menu go-top">
							<li><Link to="/autho">Author</Link></li>
							<li><Link to="/blog">Blog</Link></li>
							<li><Link to="/cat-page">Tech News</Link></li>
							<li><Link to="/cat-fashion">Fashion</Link></li>
						</ul> */}
            <p>Copyright ©2025 WE R News</p>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer_v1;
